import { useMsal } from "@azure/msal-react";
import { createContext, useState } from "react";
import { loginRequest } from "../config/formRequest/authConfig";
import { useEffect } from "react";
import { callMsGraph } from "../config/formRequest/graph";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [isLoadingUser, setLoadingUser] = useState(true);
  const [authError, setAuthError] = useState(null);
  const { instance, accounts } = useMsal();
  const account = accounts && accounts.length > 0 ? accounts[0] : null;
  const [actualUser, setActualUser] = useState(
    JSON.parse(localStorage.getItem("msal.account.keys")) &&
      JSON.parse(
        localStorage.getItem(
          JSON.parse(localStorage.getItem("msal.account.keys"))[0]
        )
      )
  );

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  const handleLogin = async () => {
    setAuthError(null);
    setLoadingUser(true);

    try {
      const res = await instance.loginPopup(loginRequest);

      // Intentamos obtener el perfil del usuario desde Graph.
      // Si falla (permisos, red, etc.), igual consideramos al usuario "logueado"
      // con la info mínima disponible en MSAL.
      try {
        const result = await callMsGraph(res.accessToken);
        if (result && !result.error) {
          setActualUser(result);
        } else {
          setActualUser(res.account || { displayName: "Usuario" });
        }
      } catch (e) {
        setActualUser(res.account || { displayName: "Usuario" });
      }

      window.location.href = "/";
    } catch (e) {
      // Si el popup está bloqueado o hay error de MSAL, mostramos algo en pantalla.
      console.log(e);
      setAuthError(e?.message || String(e));
    } finally {
      setLoadingUser(false);
    }
  };

  useEffect(() => {
    setAuthError(null);
    setLoadingUser(true);

    instance
      .initialize()
      .then(() => {
        if (!account) return;

        return instance.acquireTokenSilent({
          scopes: ["User.Read"],
          account,
        });
      })
      .then((response) => {
        if (!response) return;
        return callMsGraph(response.accessToken);
      })
      .then((result) => {
        if (result && !result.error) {
          setActualUser(result);
        }
      })
      .catch((e) => {
        // Si no hay sesión, es normal que falle (InteractionRequired), no bloqueamos la UI.
        console.log(e);
        setAuthError(e?.message || String(e));
      })
      .finally(() => {
        setLoadingUser(false);
      });
  }, [account, instance]);
  return (
    <AuthContext.Provider
      value={{ actualUser, isLoadingUser, authError, handleLogin, handleLogout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
